import { faUser, faCheck, faXmark } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  List, ListItem } from "@mui/material";
import { Card } from "../../../components/Card";
import UploadAvatar from "../UploadAvatar";
import { useIdentityContext } from "../../../context/IdentityContext";
import { getSelectedCompanyId, getUserById } from "../../../redux/Slices/account.slice";
import { useAppSelector } from "../../../redux/hooks";
import { getCompanyById } from "../../../redux/Slices/company.slice";
import { useConfig } from "../../../configContext";


export const PersonalInformation = () => {

    const { authenticatedUser } = useIdentityContext();
    const selectedCompanyId = useAppSelector(getSelectedCompanyId);
    const company = useAppSelector(getCompanyById(selectedCompanyId || authenticatedUser.companyId));
    const companyId = selectedCompanyId || company?.id;
    const user = useAppSelector(getUserById(authenticatedUser.userId));
    const config = useConfig();
    
    return (
            <Card
                id="settings-personal"
                headerIcon={faUser}
                headerTitle={`Personal Information`}
                headerSubText={`View your account configuration.`}
                showHelp={false}
                helpHeaderText=""
                helpHeaderDescription=""
                cardHeaderActions={null}
                sx={{ height: "100%", width: '100%', overflow: 'none' }}
                cardContent={
                    <div>
                        <List
                            dense={true}
                            sx={{
                                width: "100%",
                                bgcolor: "background.paper",
                                overflowY: "auto",
                                maxHeight: "75vh",
                            }}
                        >

                            <ListItem>
                                <div style={{ marginRight: "16px" }}>
                                    <UploadAvatar
                                       uploadUrl="/companycommands/UploadAvatar"
                                        imageUrl="/companyqueries/avatar"
                                        sx={{ width: 46, height: 46 }}
                                    />
                                </div>
                                <p>
                                    {user?.emailAddress}
                                    <br />
                                    <small>{user?.roles}</small>
                                </p>
                            </ListItem>
                            <ListItem>
                                <b>Name:</b>
                                &nbsp; {user?.firstName} {user?.lastName}
                            </ListItem>
                            <ListItem>
                                <b style={{ marginRight: 10 }}>Email Verified:</b>
                                {user?.isConfirmed ? (
                                    <div>
                                        <FontAwesomeIcon
                                            size="lg"
                                            color="green"
                                            icon={faCheck}
                                        />
                                    </div>
                                ) : (
                                    <div>
                                        <FontAwesomeIcon
                                            size="lg"
                                            color="red"
                                            icon={faXmark}
                                        />
                                    </div>
                                )}
                            </ListItem>
                        </List>
                    </div>
                }
            />
    )
}


